import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const getAdminPasscode = () => localStorage.getItem("grant_admin_passcode") || "";
export const setAdminPasscode = (code) => localStorage.setItem("grant_admin_passcode", code);
export const clearAdminPasscode = () => localStorage.removeItem("grant_admin_passcode");

export const adminApi = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

adminApi.interceptors.request.use((config) => {
  const code = getAdminPasscode();
  if (code) config.headers["X-Admin-Passcode"] = code;
  return config;
});

export const COACHES = {
  jacob: {
    id: "jacob",
    name: "Jacob Grant",
    age: 16,
    tagline: "FA Level 1 · UEFA C in progress · Div 1 player",
    blurb:
      "An active Division 1 player currently working towards his UEFA C, with the FA Level 1 already in the bag. Sessions with Jacob are high-energy, technically focused and built around creativity — perfect for players aged 12-16 who want to fall in love with the ball and sharpen real, modern game habits.",
    accent: "emerald",
    price: 20,
    blockPrice: 90, // 5x £18
    blockSize: 5,
    badges: ["FA Level 1", "UEFA C in progress", "Div 1 player", "Ages 12-16"],
    image: "/coaches/jacob.jpg",
  },
  james: {
    id: "james",
    name: "James Grant",
    age: null,
    tagline: "UEFA B qualified · England academy fitness coach",
    blurb:
      "UEFA B qualified with deep experience as a coach and fitness specialist inside England academy environments. James runs elite development sessions for U16-U18 players — position-specific tactical work, football fitness, and performance.",
    accent: "blue",
    price: 50,
    blockPrice: 225, // 5x £45
    blockSize: 5,
    badges: ["UEFA B", "England academy fitness", "U16-U18 elite"],
    image: "/coaches/james.jpg",
  },
};

export const SESSION_TYPES = [
  { id: "position_specific", label: "Position Specific", desc: "Tactical & technical work tailored to your role on the pitch." },
  { id: "skill_specific", label: "Skill Specific", desc: "Finishing, first touch, 1v1, passing range — pick a focus." },
  { id: "football_fitness", label: "Football Fitness", desc: "Sport-specific conditioning, speed, agility & repeat sprint capacity." },
  { id: "u16_u18_elite", label: "U16-U18 Elite (James only)", desc: "Academy-level development blocks for older players." },
];

export const LOCATIONS = [
  { id: "southampton_sports_centre", label: "Southampton Sports Centre", note: "Our home base — grass & 3G available" },
  { id: "astro", label: "Astro (3G/4G pitch)", note: "Premium surface — slightly higher fee may apply" },
  { id: "at_home", label: "At Home / Your Pitch", note: "We travel to your space — Hythe & Southampton area" },
];
